// ./src/config/bases.ts
export default {
  rebox: {
    baseUrls: {
      carAssistance: 'https://rebox2.com.br/v1.0',
      // carAssistance: 'http://localhost:3333/v1.0',
    },
    externalLinks: {
      provider: 'https://prestador.rebox.com.br',
      affiliate: 'https://afiliado.rebox.com.br',
      shareProducts: 'https://rebox.com.br/?i=',
      attachments: 'https://rebox.com.br/external/anexos',
    },
    emails: {
      contactUs: 'faleconosco@rebox.com.br',
    },
    whatsapp: {
      commercial: '551140033132',
    },
  },
  viaCep: {
    baseUrls: {
      address: 'https://viacep.com.br/ws',
    },
  },
  ibge: {
    baseUrls: {
      serviceData: 'https://servicodados.ibge.gov.br/api/v1',
    },
  },
  correio: {
    baseUrls: {
      buscaCepInter:
        'https://buscacepinter.correios.com.br/app/endereco/index.php?t',
    },
  },
  google: {
    baseUrls: {
      maps: 'https://maps.googleapis.com/maps/api',
    },
  },
  zapinho: {
    baseUrls: {
      users: 'https://api.hand.chat/core/v2/api/users',
    },
  },
  traccar: {
    rebox: {
      baseUrl: 'http://rebox-tracker.com.br:8082/api',
    },
  },
};
